import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import NotFound from '../screens/content/notFound';
import ScrollToTop from './scrollToTop';
import CustomLayout from '../screens/customLayout';
import '../translation/index';
import { screens } from '../config/routes';
import { store } from '../redux/store';
import { Provider } from 'react-redux';
import Onboarding from '../screens/auth/onboarding';
import { keys } from '../config/keys';
import Courses from '../screens/content/courses';
import CourseDetails from '../screens/content/courseDetails';
import Loader from '../connected-components/loader';

interface RequireTokenProps {
  children: JSX.Element;
}

/**
 * RequireToken: A route guard component that checks for a token.
 * If no token is found, it redirects the user to the onboarding page.
 */
const RequireToken: React.FC<RequireTokenProps> = ({ children }) => {
  const token = localStorage.getItem(keys.token);
  if (!token) {
    return <Navigate to={screens.onboarding} />;
  }
  return children;
};

const MainRouter = (): JSX.Element => {
  useEffect(() => {
    window.history.scrollRestoration = 'manual';
  }, []);

  return (
    <Provider store={store}>
      <ScrollToTop />
      <Routes>
        <Route path={screens.onboarding} element={<Onboarding />} />
        <Route element={<CustomLayout />}>
          <Route path="/" element={<Navigate to="/courses" />} />
          <Route
            path={screens.courses}
            element={
              <RequireToken>
                <Courses />
              </RequireToken>
            }
          />
          <Route
            path={`${screens.courses}/:courseTitle/:id`}
            element={
              <RequireToken>
                <CourseDetails />
              </RequireToken>
            }
          />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
      <Loader />
    </Provider>
  );
};

export default MainRouter;
